import { render, staticRenderFns } from "./Chargeback.vue?vue&type=template&id=36900a4c"
import script from "./Chargeback.vue?vue&type=script&lang=js"
export * from "./Chargeback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports